import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { Icon } from "@/components/ui/Icon";
import { ROUTES } from "@/constants/routes";
import { useAuth } from "@/hooks/useAuth";

export const AuthGuard = () => {
  const { user, isLoading, isAuthenticated, logout } = useAuth();

  useEffect(() => {
    if (!isLoading && isAuthenticated && !user) {
      logout();
    }
  }, [isLoading, isAuthenticated, user, logout]);

  // Не авторизован — на логин
  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.login}
        replace
      />
    );
  }

  if (isLoading) {
    return (
      <div className="bg-background flex h-screen w-full items-center justify-center">
        <Icon name="spinner" className="size-6 animate-spin text-neutral-500" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={ROUTES.login}
        replace
      />
    );
  }

  return <Outlet />;
};
